import { ChangeDetectionStrategy, Component } from '@angular/core';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder } from '@angular/forms';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { SwiperOptions } from 'swiper/types';
import { swiperDefaultConfig } from '@app/shared/directives/swiper.directive';

@Component({
  selector: 'evc-quote-confirmation',
  providers: [createProvider(ConfirmationComponent)],
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent extends Step {
  readonly formName = 'evcQuote';
  readonly stepName = 'confirmation';

  slidesIterator = [1, 2, 3, 4];
  swiperConfig: SwiperOptions = {
    ...swiperDefaultConfig,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: this.slidesIterator.length,
        spaceBetween: 0,
      },
    },
  };

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  toggleCheckbox(): void {
    this.writeValue({ newsletter: !this.control.get('newsletter').value });
  }

  submit(): void {
    this.formReady.emit();
  }

  writeValue(value) {
    super.writeValue(value);
  }

  protected valueChanges(values) {
    super.valueChanges(values.newsletter);
  }

  protected buildForm() {
    this.control = this.fb.group({
      newsletter: this.fb.control('', []),
    });
    this.subscribeToValueChanges(false);
  }
}
